import Keycloak from 'keycloak-js';

import { KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL } from '@/config';

declare global {
  interface Window {
    __KEYCLOAK_INSTANCE__?: Keycloak;
  }
}

const createKeycloakInstance = (): Keycloak => {
  if (window.__KEYCLOAK_INSTANCE__) {
    return window.__KEYCLOAK_INSTANCE__;
  }

  const instance = new Keycloak({
    url: KEYCLOAK_URL,
    realm: KEYCLOAK_REALM,
    clientId: KEYCLOAK_CLIENT_ID,
  });

  window.__KEYCLOAK_INSTANCE__ = instance;
  return instance;
};

export const client = createKeycloakInstance();
export default client;
